import { render, staticRenderFns } from "./PriceTableIV.vue?vue&type=template&id=1df09a4e&"
import script from "./PriceTableIV.vue?vue&type=script&lang=js&"
export * from "./PriceTableIV.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports